module.exports = __webpack_public_path__ + "img/process-human-animated.9bc6a4ba.gif";